import React from 'react';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { Box, Theme, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type ErrorModalProps = {
  isOpen: boolean;
  onClose: () => void;
  message: string;
};

const ErrorModal = ({ isOpen, onClose, message }: ErrorModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '5px',
          width: '374px',
          textAlign: 'center',
        },
      }}
    >
      <Box
        position="relative"
        py="36px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        bgcolor="#fcf0f0"
        sx={{
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: '-20px',
            left: '50%',
            transform: 'translateX(-50%)',
            borderTop: '20px solid',
            borderColor: '#fcf0f0',
            borderLeft: '20px solid transparent',
            borderRight: '20px solid transparent',
          },
        }}
      >
        <img src="/assets/icons/file-error-red.svg" alt="assign-activity" />
        <Typography
          variant="h6"
          sx={{
            color: (theme: Theme) => theme.palette.error.light,
            mt: '11px',
          }}
        >
          {t('error.fileUpload.fileUploadFailed')}
        </Typography>
      </Box>
      <Box px="32px" pt="55px" pb="36px">
        <Typography variant="bodyRegular">{message}</Typography>
        <Button
          onClick={onClose}
          variant="contained"
          color="warning"
          sx={{
            width: '100%',
            color: 'white',
            padding: '0.7rem 0',
            textTransform: 'capitalize',
            mt: '48px',
          }}
        >
          {t('common.dismiss')}
        </Button>
      </Box>
    </Dialog>
  );
};

export default ErrorModal;
